<template>
	<section id="home">
		<v-img
			:min-height="minHeight"
			:src="require('@/assets/kezdolap_felsoboritokep.jpg')"
			class="white--text"
			gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
		>
			<v-container class="fill-height px-4 py-12">
				<v-responsive
					class="d-flex align-center"
					height="100%"
					max-width="700"
					width="100%"
				>
					<h1>Testnevelésórai eredményrögzítő</h1>

					<v-body>
						A testnevelésórai eredményrögzítő programmal rögzítheti tanulói eredményeit, melyekből megadott követelmények alapján jegy kerül számításra. Hozzáadhat, tematizálhat gyakorlatokat, melyeket később akár újrahasználhat más csoportok esetében.
						A szoftver tartalmaz tapasztalt szakember által előre elkészített sablonokat, melyeket Ön könnyedén felhasználhat. A szoftver segítségével diagramokat hozhat létre tanulói eredményéből, mellyel vizuálisan is összehasonlíthatja tanulóit.
					</v-body>

					<div
						:class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
						class="d-flex flex-wrap"
					>
						<router-link  v-if="!$store.state.bejelentkezve" :to="{name: 'bejelentkezes'}">
							<v-btn
								:ripple="false"
								color="primary"
								rounded
							>
								Bejelentkezés vagy regisztráció
							</v-btn>
						</router-link>
						<router-link  v-else :to="{name: 'csoportok'}">
							<v-btn
								:ripple="false"
								color="primary"
								rounded
							>
								Tovább a szoftverre
							</v-btn>
						</router-link>
					</div>
				</v-responsive>
			</v-container>
		</v-img>
	</section>
</template>

<script>
export default {
	computed: {
		minHeight () {
			const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

			return `calc(${height} - ${this.$vuetify.application.top}px)`
		},
	},
}
</script>
